import { h } from 'preact'
import {
  connectSearchBox, SearchBoxProvided
} from 'react-instantsearch/connectors'
import InputGroupWithIcons from '../ui-components/InputGroupWithIcons'
import Icon from '../assets'
import { t } from '../../libs/translationsUtils/translations'

let timeout: undefined | number

const doSearch = (value: string, searchFunc: Function) => {
  clearTimeout(timeout)

  timeout = window.setTimeout(() => {
    searchFunc(value)
  }, 500)
}

interface Props extends SearchBoxProvided {
  enableLoader: boolean,
  defaultCdn: string,
}

const SearchBox = ({ currentRefinement, refine, defaultCdn, enableLoader }: Props) => (
  <div>
    <InputGroupWithIcons
      initialValue={currentRefinement}
      attributes={{
        type: 'search',
        placeholder: t('Forum', 'live.search.placeholder')
      }}
      className=''
      preIcon={<Icon width={24} height={24} color='#6B707E' icon='search' customClass={enableLoader ? 'opacity' : ''} />}
      onChange={(newValue: string) => doSearch(newValue, refine)}
    />
    {
      enableLoader ? (
        <span className='instant-search-loader small-loader'>
          <img
            src={`${defaultCdn}/images/spinner.gif`}
            alt='loading...' />
        </span>
      ) : null
    }
  </div>
)

const InstantSearchBox = connectSearchBox(SearchBox)

export default InstantSearchBox
